import {Transition} from './TransitionTypes';

/** Number of source PTDVs for the transition. */
export function getNumTransitionSources(transition: Transition): number {
  return transition.sourcePTDVIds.length;
}

/** True when the transition has more than one source PTDV (merging transition). */
export function isMergingTransition(transition: Transition): boolean {
  return getNumTransitionSources(transition) > 1;
}
